import { styled } from "@pigment-css/react";
import { useTranslations } from "@acto/web-common/locales";
import { GlassButton } from "@acto/taskpane/field-sales-2/components/primitives/GlassButton";

const LoadMoreButton = styled(GlassButton)(({ theme }) => ({
  width: "100%",
  color: theme.fieldSalesTwo.colors.neutral[800],
}));

interface LoadMoreFooterProps {
  hasMore: boolean;
  isLoadingMore: boolean;
  onLoadMore: () => void;
}

/** Load-more list footer; renders nothing once all rows are loaded. */
export function LoadMoreFooter({ hasMore, isLoadingMore, onLoadMore }: LoadMoreFooterProps) {
  const t = useTranslations("fieldSalesTwo");

  if (!hasMore && !isLoadingMore) return null;
  return (
    <LoadMoreButton type="button" onClick={onLoadMore} disabled={isLoadingMore}>
      {isLoadingMore ? t("home.loadingMore") : t("home.loadMore")}
    </LoadMoreButton>
  );
}
